import _ from 'lodash';
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;
const $ = require('jquery');

import "./styles.scss";

const loadAssetsJS = require('./js/loadAssets');
const serviceAreaMapJS = require('./js/serviceAreaMap');
const themeJS = require('./js/theme');

const myCarouselElement = document.querySelector('#spotlightCarousel');

if(myCarouselElement){
  const carousel = new bootstrap.Carousel(myCarouselElement, {
    interval: 10000
  });
}

// const roachVideo = document.getElementById("roachVideoPoster");
// if(roachVideo){
// 	roachVideo.setAttribute('autoPlay', true);
// 	roachVideo.setAttribute('loop', true);
// 	roachVideo.setAttribute('muted', true);
// 	roachVideo.addEventListener("ended",myHandler,false);
// }
// function myHandler(e) {
//     setTimeout(function(){
//         roachVideo.play();
//     }, 10000);
// }
